import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "flex flex-jc-sb border-bottom pd-b-10" }
const _hoisted_3 = { class: "bold" }
const _hoisted_4 = { class: "flex flex-ai-c" }
const _hoisted_5 = { class: "detail-value" }
const _hoisted_6 = { class: "detail-value" }
const _hoisted_7 = { class: "table" }
const _hoisted_8 = { class: "flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_searchComponent = _resolveComponent("searchComponent")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_export_button = _resolveComponent("export-button")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_tableComponent = _resolveComponent("tableComponent")!
  const _component_dialogDetail = _resolveComponent("dialogDetail")!
  const _component_drawerAdvanceDetail = _resolveComponent("drawerAdvanceDetail")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, {
      shadow: "never",
      class: "mg-t-20"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_searchComponent, {
          "search-list": _ctx.searchList,
          "onUpdate:searchList": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchList) = $event)),
          onDoSearch: _ctx.handleSearch
        }, null, 8, ["search-list", "onDoSearch"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      class: "mg-t-20"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.date) + " 预支单", 1),
          _createElementVNode("div", _hoisted_4, [
            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "bold" }, "累计：", -1)),
            _createElementVNode("span", _hoisted_5, "¥" + _toDisplayString(_ctx.summaryData.totalAmount), 1),
            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "bold mg-l-5" }, "共：", -1)),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.summaryData.totalCount), 1),
            _cache[6] || (_cache[6] = _createElementVNode("span", { class: "bold" }, "笔", -1)),
            _createVNode(_component_export_button, {
              class: "mg-l-20",
              size: "small",
              onExport: _ctx.onExport
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("导出勾选")
              ])),
              _: 1
            }, 8, ["onExport"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_tableComponent, {
            class: "mg-t-20",
            "table-data": _ctx.tableData,
            "table-head": _ctx.tableHead,
            onSelectionChange: _ctx.handleSelectionChange,
            "page-info": _ctx.pageInfo,
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange
          }, {
            auditStatus: _withCtx((scope) => [
              _createElementVNode("div", {
                class: _normalizeClass([`fc-${scope.row.auditStatus}`])
              }, _toDisplayString(_ctx.auditStatusMap(scope.row.auditStatus)), 3)
            ]),
            status: _withCtx((scope) => [
              _createElementVNode("div", {
                class: _normalizeClass([`fc-${scope.row.status}`])
              }, _toDisplayString(scope.row.auditStatus === 1 ? _ctx.statusMap(scope.row.status) : '--'), 3)
            ]),
            operate: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_button, {
                  type: "text",
                  size: "small",
                  onClick: ($event: any) => (_ctx.toDetail(scope.row))
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("详情")
                  ])),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  type: "text",
                  size: "small",
                  onClick: ($event: any) => (_ctx.toDrawer(scope.row))
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode("更多")
                  ])),
                  _: 2
                }, 1032, ["onClick"]),
                (scope.row.status === 0 || scope.row.status === 4)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "text",
                      class: "fc-orange",
                      size: "small",
                      onClick: ($event: any) => (_ctx.handleStop(scope.row))
                    }, {
                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createTextVNode("停止发薪")
                      ])),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["table-data", "table-head", "onSelectionChange", "page-info", "onSizeChange", "onCurrentChange"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_dialogDetail, {
      show: _ctx.showDialog,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showDialog) = $event)),
      id: _ctx.curItem.id
    }, null, 8, ["show", "id"]),
    _createVNode(_component_drawerAdvanceDetail, {
      show: _ctx.showDrawer,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showDrawer) = $event)),
      "user-id": _ctx.curItem.userId,
      "card-id": _ctx.curItem.idCardNo
    }, null, 8, ["show", "user-id", "card-id"])
  ]))
}